const clinicType = 'vet';
const isProd = process.env.REACT_APP_USER_API_URL.includes('prod');

const pricingDetails = {
    vet: {
        Free: {
            accountType: 'Free',
            productId: isProd ? 'prod_Tq6n6ANYRZntEl' : 'prod_TkV4mmkNftnrtY',
            priceMonthlyId: isProd ? 'price_1SsQZuL2Uy8HcDMuz0gRrBtr' : 'price_1Sn04TL2Uy8HcDMuN0i4oiAa',
            priceMonthly: 0,
            priceAnnually: 0,
            priceAnnuallyId: isProd ? 'price_1SsQZuL2Uy8HcDMumI9bnFT4' : 'price_1Sn04TL2Uy8HcDMuBEO4PD0r',
            benefits: [
                'Single user access',
                'View all information handouts',
                'View anatomy diagrams',
                'View 3D anatomy models',
                'Edit and annotate handouts',
                'Basic customer support',
            ],
            klaviyoListId: 'XXjqFu', // new Klaviyo list ID for Free plan
        },
        Student: {
            accountType: 'Student',
            productId: isProd ? 'prod_QjtOG8QIilyVNr' : 'prod_QXpfPHjuwthNx7',
            priceMonthlyId: isProd ? 'price_1R3uGcL2Uy8HcDMu9sPsymmb' : 'price_1QpDdKL2Uy8HcDMukMb7it5E',
            priceMonthly: 4.99,
            priceAnnually: 56.88,
            priceAnnuallyId: isProd ? 'price_1SLghQL2Uy8HcDMuHQlTrQiR' : 'price_1SLgf9L2Uy8HcDMuRiEDhFFz',
            benefits: [
                'Single user access',
                'View all information handouts',
                'View all anatomy diagrams',
                'Basic customer support',
                'Interactive whiteboard',
            ],
            // couponId: isProd ? 'LdsUb5Xv' : 'bD3OzeZP',
            klaviyoListId: 'R2gDZ3',
            legacy: true, // Mark as legacy - hidden from new signups
        },
        Professional: {
            accountType: 'Professional',
            productId: isProd ? 'prod_QjtJiFdck0KupJ' : 'prod_QXpfh4Pw3WYGiz',
            priceMonthlyId: isProd ? 'price_1R3uJmL2Uy8HcDMu38y3aLAB' : 'price_1QpDg3L2Uy8HcDMubCIaJMFf',
            priceMonthly: 9.99,
            priceAnnually: 113.88,
            priceAnnuallyId: isProd ? 'price_1R3uK8L2Uy8HcDMupfKXnrP0' : 'price_1QpDjqL2Uy8HcDMuGAM33XUk',
            benefits: [
                'Single user access',
                'View all information handouts',
                'View all anatomy diagrams',
                'View 3D anatomy models',
                'Clinic name on all handouts',
                'Personal workspace',
                'Edit and annotate handouts',
                'Unlimited saving, sharing & printing',
                'Premium customer support',
            ],
            // couponId: isProd ? 'LdsUb5Xv' : 'bD3OzeZP',
            klaviyoListId: 'Y7kVFz',
        },
        Clinic: {
            accountType: 'Clinic',
            productId: isProd ? 'prod_QjtOpkXwFHjj9x' : 'prod_QXpg8C1N3zC1Xg',
            priceMonthlyId: isProd ? 'price_1R3u6TL2Uy8HcDMuA7XRseGI' : 'price_1QpDiAL2Uy8HcDMuWBw3FHhr',
            priceMonthly: 49.99,
            priceAnnually: 569.88,
            priceAnnuallyId: isProd ? 'price_1R3u7kL2Uy8HcDMuVn3RkcmJ' : 'price_1QpDiaL2Uy8HcDMu9yaaG4ZW',
            benefits: [
                'Multi-user access (up to 5 users)',
                'View all information handouts',
                'View all anatomy diagrams',
                'View 3D anatomy models',
                'Custom branding on handouts',
                'Ability to bundle handouts',
                'Personal workspace',
                'Edit and annotate handouts',
                'Unlimited saving, sharing & printing',
                'Clinic workspace',
                'Premium customer support',
            ],
            // couponId: isProd ? 'LdsUb5Xv' : 'bD3OzeZP',
            klaviyoListId: 'SDs2NJ',
        },
        Enterprise: {
            countType: 'Enterprise',
            benefits: [
                'Multi-user access (more than 5 users)',
                'View all information handouts',
                'View all anatomy diagrams',
                'View 3D anatomy models',
                'Custom branding on handouts',
                'Ability to bundle handouts',
                'Edit and annotate handouts',
                'Personal workspace',
                'Unlimited saving, sharing & printing',
                'Clinic workspace',
                'Premium customer support',
            ],
            description:
                'Our enterprise plan is designed for larger organisations. This plan has advanced administrative and reporting functions, and is a cost effective option for institutions and businesses with multiple clinics or more than 5 users.',
            klaviyoListId: 'XJsU8z', //TODO it needs a new klaviyo list
        },
    },
};

module.exports = pricingDetails[clinicType];
